export const build = { date:"2026-03-20.1308", stage:"alpha" }
